import *  as TYPES from '../mutation-types'

export default {
  state: {
    inited: false,
    address: null,
    skus: [],
    coupon: null,
    amount: 0,
    postage: {},
    discount: 0,
    remark: '',
    pay: false,
    needPay: 0,
    bill_id: '',
    rebate: null,
    order_id: '',
    delivery: false,
    authentication: false,
    saveMoney: 3888,
    saveDesc: '',
    seckillDes: '',
    totalSaveMoney: 0,
    membership: 0,
  },

  mutations: {
    [TYPES.NEW_ORDER](state, data) {
      state.inited = true;
      state.needPay = data.needPay;
      state.address = data.address || null;
      state.skus = data.skus;
      state.coupon = data.coupon || null;
      state.amount = data.amount;
      state.postage = data.postage;
      state.rebate = data.rebate;
      state.discount = data.postage.cost + data.amount - state.needPay;
      state.delivery = data.delivery;
      state.authentication = data.authentication;
      state.saveMoney = data.saveMoney;
      state.saveDesc = data.saveDesc;
      state.seckillDes = data.seckillDes;
      state.totalSaveMoney = data.totalSaveMoney;
      state.membership = data.membership;
    },

    [TYPES.CHANGE_ORDER_ADDRESS](state, address) {
      state.address = address
    },

    [TYPES.CHANGE_ORDER_COUPON](state, data) {
      state.needPay = data.needPay;
      state.skus = data.skus;
      state.coupon = data.coupon || null;
      state.amount = data.amount;
      state.postage = data.postage;
      state.rebate = data.rebate;
      state.discount = data.postage.cost + data.amount - state.needPay;
      state.delivery = data.delivery;
      state.authentication = data.authentication;
    },

    [TYPES.CREATE_ORDER](state, {order_id, bill_id}) {
      state.order_id = order_id;
      state.bill_id = bill_id;
    },

    [TYPES.ORDER_CHANGE_COUNT] (state, {i, num}) {

      state.skus[i].quantity = parseInt(state.skus[i].quantity) + num;
    }

  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/order.js